// extracted by mini-css-extract-plugin
export default {"toggle":"Ll8P6fvn9zE0ix9kT8EH","toggleContainer":"DU9vvvgMQVT8t5QSBV2E","toggleTracker":"NLuB5rvHFrIst7f63E38","toggleLabel":"SGLXzGuXqxVHgiLBo2mi","checked":"c89CmKmIvRZEDPciFsrn"};